<template>
    <div class="B2BValues container mb-10 flex flex-col lg:mb-20">
        <div
            class="flex flex-col items-center lg:flex-row"
            :class="isButtonOnLeft ? 'justify-start' : 'justify-between'"
        >
            <CHeading class="mb-4 mr-4 lg:mb-0" tag="h2" variant="fat-italic">Naše hodnoty</CHeading>

            <CButton class="h-14 w-60" :to="{ name: 'about', hash: '#values' }" variant="primary-150">
                {{ isButtonOnLeft ? 'Chcem vedieť viac' : 'Zobraziť viac o hodnotách' }}
            </CButton>
        </div>

        <div class="mt-10 flex flex-col items-center lg:flex-row">
            <div
                class="flex size-80 flex-col items-start border-solid border-gray-200 dark:border-default pl-8 sm:w-full sm:items-center sm:pl-0 lg:w-80 lg:items-start lg:border-y lg:pl-8"
            >
                <CIcon class="mb-6 mt-14 size-10 object-cover text-primary-910 dark:text-primary-300" name="user" />

                <strong>Charakternosť</strong>

                <p class="mt-3">
                    Morálne kvality založené <br class="hidden lg:block" />
                    na morálnej odvahe, úcte <br class="hidden lg:block" />
                    k druhým a pokore.
                </p>
            </div>

            <div
                class="flex size-80 flex-col items-start border-y border-solid border-gray-200 dark:border-default pl-8 sm:w-full sm:items-center sm:pl-0 lg:w-80 lg:items-start lg:border-x lg:pl-8"
            >
                <CIcon class="mb-6 mt-14 size-10 object-cover text-primary-910 dark:text-primary-300" name="stars" />

                <strong>Excelentnosť</strong>

                <p class="mt-3">
                    Všestrannosť ako aj <br class="hidden lg:block" />
                    výnimočnosť vo svojej oblasti.
                </p>
            </div>

            <div
                class="flex size-80 flex-col items-start border-y border-solid border-gray-200 dark:border-default pl-8 sm:w-full sm:items-center sm:pl-0 lg:w-80 lg:items-start lg:border-r lg:pl-8"
            >
                <CIcon class="mb-6 mt-14 size-10 object-cover text-primary-910 dark:text-primary-300" name="arrow-inside-circle" />

                <strong>Podnikavé líderstvo</strong>

                <p class="mt-3">
                    Snaha o neustále <br class="hidden lg:block" />
                    vylepšovanie, podporená <br class="hidden lg:block" />
                    vysokými ašpiráciami.
                </p>
            </div>

            <div
                class="flex size-80 flex-col items-start border-solid border-gray-200 dark:border-default pl-8 sm:w-full sm:items-center sm:pl-0 lg:w-80 lg:items-start lg:border-y lg:pl-8"
            >
                <CIcon class="mb-6 mt-14 size-10 object-cover text-primary-910 dark:text-primary-300" name="hand-hand" />

                <strong>Občianska angažovanosť</strong>

                <p class="mt-3">
                    Predsavzatie nezištne <br class="hidden lg:block" />
                    pomáhať širšiemu okoliu, <br class="hidden lg:block" />
                    ktoré vychádza z vďačnosti.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'
import CHeading from '@/components/ui/CHeading.vue'
import CIcon from '@/components/ui/CIcon.vue'

defineProps({
    isButtonOnLeft: {
        type: Boolean,
        default: false
    }
})
</script>
